import UrnIndex from '@p/urn/UrnIndex'

export const urnRootPages = {
  path: 'urn',
  name: 'urn_index_route',
  component: UrnIndex
}
